export const recordTypeMap = {
  'Certificate of Preference (COP)': 'COP',
  'Displaced Tenant Housing Preference (DTHP)': 'DTHP',
  'Live or Work in San Francisco Preference': 'L_W',
  'Neighborhood Resident Housing Preference (NRHP)': 'NRHP',
  'Rent Burdened / Assisted Housing Preference': 'RB_AHP',
  'Anti-Displacement Housing Preference (ADHP)': 'ADHP',
  'Alice Griffith Housing Development Resident': 'AG'
}

export const typeOfProofValues = [
  'Letter from SFHA verifying address',
  "CA ID or Driver's License",
  'Telephone bill (landline only)',
  'Cable and internet bill',
  'Paystub (listing home address)',
  'Public benefits record',
  'School record'
]
// NOTE: all possible type proofs. Leaving this as record for now.
// Letter from SFHA verifying address
// CA ID or Driver's License
// Telephone bill (landline only)
// Telephone bill
// Cable and internet bill
// Paystub (listing home address)
// Gas bill
// Electric bill
// Garbage bill
// Water bill
// Paystub
// Public benefits record
// School record
// Paystub with employer address
// Letter from employer
// Letter documenting homelessness
// Lease and rent proof
// Lease
// Custom Proof
